import { render } from "./HostgroupsIndex.vue?vue&type=template&id=0c66a9da"
import script from "./HostgroupsIndex.vue?vue&type=script&lang=js"
export * from "./HostgroupsIndex.vue?vue&type=script&lang=js"

import exportComponent from "/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__